import React from 'react';

const IntegrationGuidesIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="mask0_1548_5060" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
      <rect width="16" height="16" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_1548_5060)">
      <path d="M2.87191 13C2.53514 13 2.25008 12.8833 2.01675 12.65C1.78341 12.4167 1.66675 12.1316 1.66675 11.7948V4.20517C1.66675 3.86839 1.78341 3.58333 2.01675 3.35C2.25008 3.11667 2.53514 3 2.87191 3H6.03341C6.19408 3 6.34858 3.03122 6.49691 3.09367C6.64514 3.156 6.77397 3.24189 6.88341 3.35133L7.86541 4.33333H13.1282C13.465 4.33333 13.7501 4.45 13.9834 4.68333C14.2167 4.91667 14.3334 5.20172 14.3334 5.5385V11.7948C14.3334 12.1316 14.2167 12.4167 13.9834 12.65C13.7501 12.8833 13.465 13 13.1282 13H2.87191ZM2.87191 12H13.1282C13.1881 12 13.2373 11.9808 13.2757 11.9423C13.3142 11.9039 13.3334 11.8547 13.3334 11.7948V5.5385C13.3334 5.47861 13.3142 5.42945 13.2757 5.391C13.2373 5.35256 13.1881 5.33333 13.1282 5.33333H7.45641L6.18091 4.05767C6.15947 4.03633 6.13703 4.02139 6.11358 4.01283C6.09003 4.00428 6.06541 4 6.03975 4H2.87191C2.81203 4 2.76286 4.01922 2.72441 4.05767C2.68597 4.09611 2.66675 4.14528 2.66675 4.20517V11.7948C2.66675 11.8547 2.68597 11.9039 2.72441 11.9423C2.76286 11.9808 2.81203 12 2.87191 12Z" fill="currentColor" />
    </g>
  </svg>
);

export default IntegrationGuidesIcon;
